import React, {useContext, useEffect, useState} from "react"
import DataContext from "../context/DataContext"
import {formatImageSrc} from "../strapi/strapiHelpers"
import {useRouter} from "next/router"
import useCache from "./useCache"
import {logger} from "../utility/Helper"
import {fetchGet} from "../firebaseAdmin/fetchGet"

function useFilterRelevantBrands(quizzData, step) {
	const [brandsToShow, setBrandsToShow] = useState([])
	const router = useRouter()
	const {brands} = useContext(DataContext)
	const [brandsList, setBrandsList] = useState(() => [])

	useEffect(() => {
		try {
			fetchGet(`/api/products/get-category-brands?categories=${[...(quizzData?.subCategories?.filter(Boolean) || [])].join(",")}&locale=${router.locale}`).then(data => data.json()).then(data => {
				const options = data?.brands?.map(brand => {
					const brandInStrapi = brands.find(strapiBrand => strapiBrand?.fields?.slug === brand?.value)

					return {...brand, imageSrc: brandInStrapi?.fields?.icon?.image?.data?.attributes?.url ? formatImageSrc(brandInStrapi.fields?.icon?.image?.data?.attributes?.url || null) : null}
				}
				)

				setBrandsList(() => options)
				setBrandsToShow(() => options)
			})
		} catch (error) {
			logger.error(error)
		}
	}, [step])

	return {brandsList, brandsToShow, setBrandsToShow}
}

export default useFilterRelevantBrands
